export default "__VITE_ASSET__BLJAstlw__"